import React from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCardTitle,
  CCardText,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilLockLocked } from "@coreui/icons";

function AccessDenied() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "60vh" }}
    >
      <CCard className="text-center shadow-sm" style={{ maxWidth: "480px", width: "100%" }}>
        <CCardHeader className="bg-danger text-white">
          <CIcon icon={cilLockLocked} className="me-2" />
          Access Denied
        </CCardHeader>

        <CCardBody>
          <CIcon
            icon={cilLockLocked}
            size="xxl"
            className="text-danger mb-3"
            style={{ width: "60px", height: "60px" }}
          />

          <CCardTitle className="mb-2">You don’t have permission</CCardTitle>

          <CCardText className="mb-4 text-medium-emphasis">
            Your account is not allowed to access this page or perform this
            action.  
            <br /> Please contact your administrator if you believe this is a
            mistake.
          </CCardText>
        </CCardBody>
      </CCard>
    </div>
  );
}

export default AccessDenied;
